export default "__VITE_ASSET__DnnQ_71d__"